import React, { useEffect, useState, useRef } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import fieldStatus from "helpers/fieldStatus"
import submitData from "helpers/submitData"
import { Formik, Field, Form, FieldArray } from "formik"
import communityFields from "models/community"
import usStates from "models/usStates"
import * as Yup from "yup"
import ReactSelect from "components/ReactSelect"
import DateField from "components/DateField"
import nullToEmptyString from "helpers/nullToEmptyString"
import { useHistory } from "react-router-dom"
import _ from "lodash"
import Title from "../general/title"
import { toast } from "react-toastify"
import NumberField from "components/NumberField"
import TextArea from "components/TextArea"
import matchModel from "helpers/matchModel"
import HTMLEditor from "components/HTMLEditor"
import Typeahead from "components/Typeahead"
import settings from "settings"
import ColorPicker from "components/ColorPicker"
import superagent from "superagent"
import TableRowField from "components/TableRowField"
import classNames from "classnames"
import numeral from "numeral"

function EditCommunity(props) {
	const [fields, setFields] = useState(communityFields)
	const [taxRates, setTaxRates] = useState([])
	const history = useHistory()
	const [taxTemp, setTaxTemp] = useState(0) // This is storage for updating tax rates in the typeahead.  State sends 0's sometimes, so user can edit.

	useEffect(() => {
		if (props.payloadStatus) {
			pullCommunity()
		}
	}, [props.payloadStatus])

	const pullCommunity = async () => {
		let id = props.match.params.id
		if (id) {
			let resp = await submitData("mainRetrieve", {
				id: parseInt(id),
				action: "getCommunity",
			})
			if (resp.status === 200) {
				let community = resp.data
				if (community.tax_rates && community.tax_rates.length > 0) setTaxRates(community.tax_rates)
				community = matchModel(fields, community)
				community = nullToEmptyString(community)
				setFields(community)
			}
		}
	}

	const validation = () => {
		return Yup.object().shape({
			name: Yup.string().required("Required"),
			startDate: Yup.number().required("Required"),
			state: Yup.string().required("Required"),
		})
	}

	const submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	const transformStates = () => {
		let opts = []
		_.forEach(usStates, (v, k) => {
			opts.push({ label: v, value: k })
		})
		return opts
	}

	const transformMetro = () => {
		let opts = []
		_.forEach(props.payload.public.metro, (v) => {
			opts.push({ label: v.name, value: v.id })
		})
		return opts
	}

	const transformDevelopers = () => {
		let opts = []
		_.forEach(props.payload.public.developers, (v) => {
			opts.push({ label: v.name, value: v.id })
		})
		return opts
	}

	const options = (name) => {
		let opts = []
		_.forEach(props.payload.public[name], (v) => {
			opts.push({ label: v.name, value: v.id })
		})
		return opts
	}

	if (!props.payloadStatus) {
		return ""
	} else {
		let states = transformStates()
		let metro = transformMetro()
		let county = options("counties")
		let developers = transformDevelopers()
		let portalModel = {
			title: "",
			link: "",
			color: "blue",
		}
		let taxTotal = 0
		if (taxRates.length > 0) {
			taxTotal = _.sumBy(taxRates, (v) => parseFloat(v.rate))
		}
		let devServAgree
		if (fields?.finance_data?.development_services_agreement) {
			devServAgree = fields?.finance_data?.development_services_agreement
		}
		let currentLoan
		if (fields?.finance_data?.current_loan_agreement) {
			currentLoan = fields?.finance_data?.current_loan_agreement
		}
		return (
			<div>
				<Title title="Edit Community" showDate={false} />
				<div className="content">
					<h3 />
					<Formik
						enableReinitialize
						validateOnMount={true}
						initialValues={fields}
						validationSchema={validation}
						onSubmit={(values) => {
							values.id = parseInt(props.match.params.id)
							delete values.section_geo
							delete values.accounts
							let json = JSON.stringify(values)
							props.loadingStatus(true)
							/* var fd = new FormData()
							for (let k in values) {
								fd.append(k, values[k])
							} */
							var user = localStorage.getItem("user")
							let req = superagent
								.post(settings.ep + "/updateCommunity")
								.field("data", json)
								.set("Authorization", user)
							if (
								values?.finance_data?.development_services_agreement &&
								typeof values?.finance_data?.development_services_agreement === "object"
							) {
								req.attach(
									"development_services_agreement",
									values?.finance_data?.development_services_agreement
								)
							}
							if (
								values?.finance_data?.current_loan_agreement &&
								typeof values?.finance_data?.current_loan_agreement === "object"
							) {
								req.attach("current_loan_agreement", values?.finance_data?.current_loan_agreement)
							}
							req.end((err, resp) => {
								if (err) {
									console.log(err)
									toast.error("Error updating community.")
									return
								}

								toast.success(resp.body.message)
								props.getPayload()
								history.push("/admin/communities")
								props.loadingStatus(false)
							})
						}}>
						{(f) => (
							<div className="editCommunity">
								{/* console.log(f) */}
								<Form>
									<ul className="form__list">
										<li className={fieldStatus("name", f)}>
											<label htmlFor="name">
												Name <sup>*</sup>
											</label>
											{f.errors.name && f.touched.name && (
												<div className="form__message">{f.errors.name}</div>
											)}
											<Field name="name" type="text" className="form__input" />
										</li>
										<li className={fieldStatus("url", f)}>
											<label htmlFor="url">
												URL <sup>*</sup>
											</label>
											{f.errors.url && f.touched.url && (
												<div className="form__message">{f.errors.url}</div>
											)}
											<Field name="url" type="text" className="form__input" />
										</li>
										<li className={fieldStatus("inventory_url", f)}>
											<label htmlFor="inventory_url">Inventory URL</label>
											{f.errors.inventory_url && f.touched.inventory_url && (
												<div className="form__message">{f.errors.inventory_url}</div>
											)}
											<Field name="inventory_url" type="text" className="form__input" />
										</li>
										<li className={fieldStatus("startDate", f)}>
											<label htmlFor="startDate">
												Start Date <sup>*</sup>
											</label>
											{f.errors.startDate && f.touched.startDate && (
												<div className="form__message">{f.errors.startDate}</div>
											)}
											<DateField
												name="startDate"
												className="form__textarea"
												value={f.values.startDate}
												onChange={f.setFieldValue}
												onBlur={f.setFieldTouched}
												touched={f.touched.startDate}
												error={f.errors.startDate}
												blockFuture={true}
											/>
										</li>
										<li className={fieldStatus("city", f)}>
											<label htmlFor="city">City</label>
											{f.errors.city && f.touched.city && (
												<div className="form__message">{f.errors.city}</div>
											)}
											<Field name="city" type="text" className="form__input" />
										</li>
										<li className={fieldStatus("zip", f)}>
											<label htmlFor="zip">Zip</label>
											{f.errors.zip && f.touched.zip && (
												<div className="form__message">{f.errors.zip}</div>
											)}
											<Field name="zip" type="text" className="form__input" />
										</li>
										<li className={fieldStatus("state", f)}>
											<label htmlFor="state">
												State <sup>*</sup>
											</label>
											{f.errors.state && f.touched.state && (
												<div className="form__message">{f.errors.state}</div>
											)}
											<ReactSelect
												name={`state`}
												options={states}
												value={f.values.state}
												onBlur={f.setFieldTouched}
												onChange={f.setFieldValue}
											/>
										</li>
										<li className={fieldStatus("metro_group", f)}>
											<label htmlFor="metro_group">
												Metro Group <sup>*</sup>
											</label>
											{f.errors.metro_group && f.touched.metro_group && (
												<div className="form__message">{f.errors.metro_group}</div>
											)}
											<ReactSelect
												name={`metro_group`}
												options={metro}
												value={f.values.metro_group}
												onBlur={f.setFieldTouched}
												onChange={f.setFieldValue}
											/>
										</li>
										<li className={fieldStatus("metro_sub_group", f)}>
											<label htmlFor="metro_sub_group">
												Metro Sub Group <sup>*</sup>
											</label>
											{f.errors.metro_sub_group && f.touched.metro_sub_group && (
												<div className="form__message">{f.errors.metro_sub_group}</div>
											)}
											<ReactSelect
												name={`metro_sub_group`}
												options={options("metroSub")}
												value={f.values.metro_sub_group}
												onBlur={f.setFieldTouched}
												onChange={f.setFieldValue}
											/>
										</li>
										<li className={fieldStatus("county", f)}>
											<label htmlFor="county">County</label>
											{f.errors.county && f.touched.county && (
												<div className="form__message">{f.errors.county}</div>
											)}
											<ReactSelect
												name={`county`}
												options={county}
												value={f.values.county}
												onBlur={f.setFieldTouched}
												clearable
												onChange={f.setFieldValue}
											/>
										</li>
										<li className={fieldStatus("lat", f)}>
											<label htmlFor="lat">Latitude</label>
											{f.errors.lat && f.touched.lat && (
												<div className="form__message">{f.errors.lat}</div>
											)}
											<NumberField
												name="lat"
												type="text"
												className="form__input"
												onChange={f.setFieldValue}
												onBlur={f.setFieldTouched}
												touched={f.touched.lat}
												error={f.errors.lat}
												value={f.values.lat}
												float={true}
												coord={true}
											/>
										</li>
										<li className={fieldStatus("lng", f)}>
											<label htmlFor="lng">Longitude</label>
											{f.errors.lng && f.touched.lng && (
												<div className="form__message">{f.errors.lng}</div>
											)}
											<NumberField
												name="lng"
												type="text"
												className="form__input"
												onChange={f.setFieldValue}
												onBlur={f.setFieldTouched}
												touched={f.touched.lng}
												error={f.errors.lng}
												value={f.values.lng}
												float={true}
												coord={true}
											/>
										</li>
										<li className={fieldStatus("color", f)}>
											<label htmlFor="color">
												Primary Color{" "}
												<span className="small">
													<i className={`fas fa-info-circle`} style={{ marginRight: 5 }} />
													Hex Code
												</span>
											</label>
											{f.errors.color && f.touched.color && (
												<div className="form__message">{f.errors.color}</div>
											)}
											<Field name="color" type="text" className="form__input" />
											<ColorPicker
												name={`color`}
												value={f.values.color}
												onChange={(v) => f.setFieldValue("color", v)}
											/>
										</li>
										<li className={fieldStatus("secondary_color", f)}>
											<label htmlFor="secondary_color">
												Secondary Color{" "}
												<span className="small">
													<i className={`fas fa-info-circle`} style={{ marginRight: 5 }} />
													Hex Code
												</span>
											</label>
											{f.errors.secondary_color && f.touched.secondary_color && (
												<div className="form__message">{f.errors.secondary_color}</div>
											)}
											<Field name="secondary_color" type="text" className="form__input" />
											<ColorPicker
												name={`secondary_color`}
												value={f.values.secondary_color}
												onChange={(v) => f.setFieldValue("secondary_color", v)}
											/>
										</li>
										<li className={fieldStatus("accent_color", f)}>
											<label htmlFor="accent_color">
												Accent Color{" "}
												<span className="small">
													<i className={`fas fa-info-circle`} style={{ marginRight: 5 }} />
													Hex Code
												</span>
											</label>
											{f.errors.accent_color && f.touched.accent_color && (
												<div className="form__message">{f.errors.accent_color}</div>
											)}
											<Field name="accent_color" type="text" className="form__input" />
											<ColorPicker
												name={`accent_color`}
												value={f.values.accent_color}
												onChange={(v) => f.setFieldValue("accent_color", v)}
											/>
										</li>
										<li className={fieldStatus("developers", f)}>
											<label htmlFor="developers">Developers</label>
											{f.errors.developers && f.touched.developers && (
												<div className="form__message">{f.errors.developers}</div>
											)}
											<ReactSelect
												name={`developers`}
												options={developers}
												isMulti
												value={f.values.developers}
												onBlur={f.setFieldTouched}
												onChange={f.setFieldValue}
											/>
										</li>
										<li className={fieldStatus("facebook", f)}>
											<label htmlFor="facebook">Facebook</label>
											{f.errors.facebook && f.touched.facebook && (
												<div className="form__message">{f.errors.facebook}</div>
											)}
											<Field name="facebook" type="text" className="form__input" />
										</li>
										<li className={fieldStatus("instagram", f)}>
											<label htmlFor="instagram">Instagram</label>
											{f.errors.instagram && f.touched.instagram && (
												<div className="form__message">{f.errors.instagram}</div>
											)}
											<Field name="instagram" type="text" className="form__input" />
										</li>
										<li className={fieldStatus("youtube", f)}>
											<label htmlFor="youtube">Youtube</label>
											{f.errors.youtube && f.touched.youtube && (
												<div className="form__message">{f.errors.youtube}</div>
											)}
											<Field name="youtube" type="text" className="form__input" />
										</li>
										<li className={fieldStatus("active", f)}>
											<label htmlFor="active">Active</label>
											{f.errors.active && f.touched.active && (
												<div className="form__message">{f.errors.active}</div>
											)}
											<ReactSelect
												name={`active`}
												options={[
													{
														label: "No",
														value: 0,
													},
													{
														label: "Yes",
														value: 1,
													},
												]}
												value={f.values.active}
												onBlur={f.setFieldTouched}
												onChange={f.setFieldValue}
											/>
										</li>
										{settings.enabled.zonda && (
											<li className={fieldStatus("competitors", f)}>
												<label htmlFor="competitors">Competitors</label>
												{f.errors.competitors && f.touched.competitors && (
													<div className="form__message">{f.errors.competitors}</div>
												)}
												<ReactSelect
													name={`competitors`}
													options={_.map(props.payload.public.zonda?.communities, (v) => {
														return { value: v.id, label: v.name }
													})}
													isMulti
													value={f.values.competitors}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
										)}
										<li className={fieldStatus("builders", f, false, false, true)}>
											<label htmlFor="builders">Builders</label>
											{f.errors.builders && f.touched.builders && (
												<div className="form__message">{f.errors.builders}</div>
											)}
											<ReactSelect
												name={`builders`}
												options={_.map(props.payload.public.builders, (v) => {
													return {
														label: v.name,
														value: v.id,
													}
												})}
												isMulti
												value={f.values.builders}
												onBlur={f.setFieldTouched}
												onChange={f.setFieldValue}
											/>
										</li>
										<li className={fieldStatus("notify_emails", f)}>
											<label htmlFor="notify_emails">Builder Admins</label>
											<p className="small">(Receives notifications)</p>
											{f.errors.notify_emails && f.touched.notify_emails && (
												<div className="form__message">{f.errors.notify_emails}</div>
											)}
											<TextArea
												name="notify_emails"
												className="form__textarea"
												value={f.values.notify_emails}
												onChange={f.setFieldValue}
												onBlur={f.setFieldTouched}
												touched={f.touched.notify_emails}
												error={f.errors.notify_emails}
											/>
										</li>
										{settings.arc && (
											<li className={fieldStatus("arc_emails", f)}>
												<label htmlFor="arc_emails">ARC Emails</label>
												<p className="small">(Receives approvals and rejections.)</p>
												{f.errors.arc_emails && f.touched.arc_emails && (
													<div className="form__message">{f.errors.arc_emails}</div>
												)}
												<TextArea
													name="arc_emails"
													className="form__textarea"
													value={f.values.arc_emails}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.arc_emails}
													error={f.errors.arc_emails}
												/>
											</li>
										)}
										<li className={fieldStatus("community_admins", f)}>
											<label htmlFor="community_admins">Community Admins</label>
											<p className="small">(Receives notifications)</p>
											{f.errors.community_admins && f.touched.community_admins && (
												<div className="form__message">{f.errors.community_admins}</div>
											)}
											<TextArea
												name="community_admins"
												className="form__textarea"
												value={f.values.community_admins}
												onChange={f.setFieldValue}
												onBlur={f.setFieldTouched}
												touched={f.touched.community_admins}
												error={f.errors.community_admins}
											/>
										</li>
										<li className={fieldStatus("addl_weekly_emails", f)}>
											<label htmlFor="addl_weekly_emails">Additional Weekly Emails</label>
											<p className="small">Comma-separated list of emails</p>
											{f.errors.addl_weekly_emails && f.touched.addl_weekly_emails && (
												<div className="form__message">{f.errors.addl_weekly_emails}</div>
											)}
											<TextArea
												name="addl_weekly_emails"
												className="form__textarea"
												value={f.values.addl_weekly_emails}
												onChange={f.setFieldValue}
												onBlur={f.setFieldTouched}
												touched={f.touched.addl_weekly_emails}
												error={f.errors.addl_weekly_emails}
											/>
										</li>
										<li className={fieldStatus("info_center_email", f)}>
											<label htmlFor="info_center_email">Info Center Email</label>
											{f.errors.info_center_email && f.touched.info_center_email && (
												<div className="form__message">{f.errors.info_center_email}</div>
											)}
											<Field name="info_center_email" type="text" className="form__input" />
										</li>
										<li className={fieldStatus("portal_links", f, false, false, true)}>
											<label htmlFor="portal_links">Builder Portal Links</label>
											{f.errors.portal_links && f.touched.portal_links && (
												<div className="form__message">{f.errors.portal_links}</div>
											)}
											<FieldArray
												name="portal_links"
												className="form__fieldArray"
												render={(arrayHelpers) => (
													<div>
														{f.values.portal_links.length > 0 ? (
															f.values.portal_links.map((friend, index) => (
																<div key={index}>
																	<Field
																		name={`portal_links.${index}.title`}
																		className="form__fieldArrayInput"
																		placeholder="Title"
																	/>
																	<Field
																		name={`portal_links.${index}.link`}
																		className="form__fieldArrayInput"
																		placeholder="Link"
																	/>
																	<ReactSelect
																		name={`portal_links.${index}.color`}
																		value={f.values.portal_links[index].color}
																		className="form__fieldArrayInput"
																		options={[
																			{
																				label: "Blue",
																				value: "blue",
																			},
																			{
																				label: "Red",
																				value: "red",
																			},
																			{
																				label: "Orange",
																				value: "orange",
																			},
																			{
																				label: "Green",
																				value: "darkGreen",
																			},
																		]}
																		onBlur={f.setFieldTouched}
																		onChange={f.setFieldValue}
																	/>
																	<button
																		type="button"
																		className="form__arrayButton px-2"
																		onClick={() => arrayHelpers.remove(index)}>
																		-
																	</button>
																	<button
																		type="button"
																		className="form__arrayButton px-2"
																		onClick={() =>
																			arrayHelpers.insert(
																				index,
																				_.clone(portalModel)
																			)
																		}>
																		+
																	</button>
																</div>
															))
														) : (
															<button
																type="button"
																className="form__arrayButtonAdd"
																onClick={() => arrayHelpers.push(_.clone(portalModel))}>
																Add a link
															</button>
														)}
													</div>
												)}
											/>
										</li>
										<li className={fieldStatus("portal_message", f)}>
											<label htmlFor="portal_message">Builder Portal Messaging</label>
											{f.errors.portal_message && f.touched.portal_message && (
												<div className="form__message">{f.errors.portal_message}</div>
											)}
											<div className="form__bigHTML">
												<HTMLEditor
													name={"portal_message"}
													className="form__textarea"
													value={f.values.portal_message}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
												/>
											</div>
										</li>
										<li className={fieldStatus("weekly_message", f)}>
											<label htmlFor="weekly_message">Weekly Report Message</label>
											{f.errors.weekly_message && f.touched.weekly_message && (
												<div className="form__message">{f.errors.weekly_message}</div>
											)}
											<div className="form__bigHTML">
												<HTMLEditor
													name={"weekly_message"}
													className="form__textarea"
													value={f.values.weekly_message}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
												/>
											</div>
										</li>
									</ul>
									{settings.lotContracts ? (
										<div className="reportGroup mt-24 border border-dashed border-blue">
											<h2>Financial Data</h2>
											<ul className="form__list">
												<li className={fieldStatus("finance_name", f)}>
													<label htmlFor="finance_name">Finance Name</label>
													{f.errors.finance_name && f.touched.finance_name && (
														<div className="form__message">{f.errors.finance_name}</div>
													)}
													<Field
														name="finance_data.finance_name"
														type="text"
														className="form__input"
													/>
												</li>
												<li className={fieldStatus("finance_address", f)}>
													<label htmlFor="finance_address">Finance Address</label>
													{f.errors.finance_address && f.touched.finance_address && (
														<div className="form__message">{f.errors.finance_address}</div>
													)}
													<Field
														name="finance_data.finance_address"
														type="text"
														className="form__input"
													/>
												</li>
												<li className={fieldStatus("finance_city", f)}>
													<label htmlFor="finance_city">Finance City</label>
													{f.errors.finance_city && f.touched.finance_city && (
														<div className="form__message">{f.errors.finance_city}</div>
													)}
													<Field
														name="finance_data.finance_city"
														type="text"
														className="form__input"
													/>
												</li>
												<li className={fieldStatus("finance_state", f)}>
													<label htmlFor="finance_state">Finance State</label>
													{f.errors.finance_state && f.touched.finance_state && (
														<div className="form__message">{f.errors.finance_state}</div>
													)}
													<ReactSelect
														name="finance_data.finance_state"
														options={props.payload.public.states}
														className="form__input"
														value={f.values.finance_data.finance_state}
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.finance_state}
														error={f.errors.finance_state}
													/>
												</li>
												<li className={fieldStatus("finance_zip", f)}>
													<label htmlFor="finance_zip">Finance Zip</label>
													{f.errors.finance_zip && f.touched.finance_zip && (
														<div className="form__message">{f.errors.finance_zip}</div>
													)}
													<Field
														name="finance_data.finance_zip"
														type="text"
														className="form__input"
													/>
												</li>
												<li className={fieldStatus("finance_phone", f)}>
													<label htmlFor="finance_phone">Finance Phone</label>
													{f.errors.finance_phone && f.touched.finance_phone && (
														<div className="form__message">{f.errors.finance_phone}</div>
													)}
													<NumberField
														name={`finance_data.finance_phone`}
														value={f.values.finance_data.finance_phone}
														format="+1 (###) ###-####"
														className="form__input"
														isNumericString
														onChange={(name, v) => {
															f.setFieldValue(`finance_data.finance_phone`, v)
														}}
														onBlur={() => f.setFieldTouched("finance_phone", true)}
													/>
												</li>
												<li className={fieldStatus("finance_email", f)}>
													<label htmlFor="finance_email">Finance Email</label>
													{f.errors.finance_email && f.touched.finance_email && (
														<div className="form__message">{f.errors.finance_email}</div>
													)}
													<Field
														name="finance_data.finance_email"
														type="text"
														className="form__input"
													/>
												</li>
											</ul>
											<h2>Buyer Obligations</h2>
											<ul className="form__list">
												<li className={fieldStatus("hoa_schedule", f)}>
													<label htmlFor="hoa_schedule">
														HOA Annual or Quarterly <sup>*</sup>
													</label>
													{f.errors.hoa_schedule && f.touched.hoa_schedule && (
														<div className="form__message">{f.errors.hoa_schedule}</div>
													)}
													<ReactSelect
														name={`finance_data.hoa_schedule`}
														options={[
															{ value: "quarterly", label: "Quarterly" },
															{ value: "annual", label: "Annual" },
														]}
														value={f.values.finance_data.hoa_schedule}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("hoa_first_day", f)}>
													<label htmlFor="hoa_first_day" className="pb-0">
														HOA Year End Date
													</label>
													{f.errors.hoa_first_day && f.touched.hoa_first_day && (
														<div className="form__message">{f.errors.hoa_first_day}</div>
													)}
													<p className="text-xs pb-3">
														Only fill in if the last day of the HOA year isn't December 31.
													</p>
													<DateField
														name="finance_data.hoa_first_day"
														className="form__textarea"
														value={f.values.finance_data.hoa_first_day}
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.hoa_first_day}
														error={f.errors.hoa_first_day}
													/>
												</li>
												<li className={fieldStatus("hoa", f)}>
													<label htmlFor="hoa">Builder Assessment (HOA) - All Lots</label>
													{f.errors.hoa && f.touched.hoa && (
														<div className="form__message">{f.errors.hoa}</div>
													)}
													<NumberField
														name="finance_data.hoa"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched?.finance_data?.hoa}
														value={f.values.finance_data.hoa}
														thousandSeparator={true}
														decimals={2}
														prefix={"$"}
													/>
												</li>

												<li className={fieldStatus("funds_hoa", f)}>
													<label htmlFor="funds_hoa">Funds HOA</label>
													{f.errors.funds_hoa && f.touched.funds_hoa && (
														<div className="form__message">{f.errors.funds_hoa}</div>
													)}
													<TextArea
														name="finance_data.funds_hoa"
														className="form__textarea"
														value={f.values.finance_data.funds_hoa}
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.funds_hoa}
														error={f.errors.funds_hoa}
													/>
												</li>
											</ul>
											<div className="border border-gray-400 rounded-lg py-6 px-3 mb-5">
												<h3>HOA Fees By Lot Type</h3>
												<p className="text-xs">
													If HOA fees are different per lot type, add them here.
												</p>
												<TableRowField
													delete={true}
													fields={[
														{
															type: "number",
															name: "amount",
															float: true,
															decimals: 2,
															header: "Amount",
														},
														{
															type: "select",
															name: "lot_type",
															clearable: true,
															placeholder: "All Lots",
															lookup: "lot_types",
															header: "Lot Type",
															dependent: "property",
															dependentVal: props.activeProperties?.[0],
														},
													]}
													data={f.values.finance_data.hoa_fees}
													onChange={(v) => f.setFieldValue("finance_data.hoa_fees", v)}
												/>
											</div>
											<div className="border border-gray-400 rounded-lg py-6 px-3">
												<h3>Buyer Fees</h3>
												<TableRowField
													delete={true}
													fields={[
														{
															type: "text",
															name: "name",
															header: "Name",
														},
														{
															type: "number",
															name: "amount",
															float: true,
															decimals: 2,
															header: "Amount",
														},
														{
															type: "select",
															name: "lot_type",
															lookup: "lot_types",
															header: "Lot Type",
															clearable: true,
															placeholder: "All Lots",
															dependent: "property",
															dependentVal: props.activeProperties?.[0],
														},
														{
															type: "textarea",
															name: "wire",
															header: "Wire Instructions",
														},
													]}
													data={f.values.finance_data.buyer_fees}
													onChange={(v) => f.setFieldValue("finance_data.buyer_fees", v)}
												/>
											</div>
											<h2>Seller Obligations</h2>
											<ul className="form__list">
												<li className={fieldStatus("development_fee", f)}>
													<label htmlFor="development_fee">Development Fee (Gross)</label>
													{f.errors.development_fee && f.touched.development_fee && (
														<div className="form__message">{f.errors.development_fee}</div>
													)}
													<NumberField
														name="finance_data.development_fee"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched?.finance_data?.development_fee}
														value={f.values.finance_data.development_fee}
														thousandSeparator={true}
														decimals={8}
														float={true}
													/>
												</li>
												<li className={fieldStatus("funds_development", f)}>
													<label htmlFor="funds_development">Funds Development</label>
													{f.errors.funds_development && f.touched.funds_development && (
														<div className="form__message">
															{f.errors.funds_development}
														</div>
													)}
													<TextArea
														name="finance_data.funds_development"
														className="form__textarea"
														value={f.values.finance_data.funds_development}
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.funds_development}
														error={f.errors.funds_development}
													/>
												</li>
												<li
													className={fieldStatus(
														"finance_data.development_services_agreement",
														f
													)}>
													<label htmlFor="finance_data.development_services_agreement">
														Development Services Agreement{" "}
														{devServAgree ? (
															<a
																href={settings.s3 + devServAgree}
																target="_blank"
																className="text-xs ml-2">
																[Current File]
															</a>
														) : (
															""
														)}
													</label>
													<input
														name="finance_data.development_services_agreement"
														type="file"
														id="finance_data.development_services_agreement"
														className={classNames("noBorder", {
															fileHideText:
																fields?.finance_data?.development_services_agreement,
														})}
														//className="noBorder fileHideText"
														onChange={(event) => {
															f.setFieldValue(
																"finance_data.development_services_agreement",
																event.currentTarget.files[0]
															)
														}}
													/>
												</li>
											</ul>
											<div className="border border-gray-400 rounded-lg py-6 px-3">
												<TableRowField
													delete={true}
													fields={[
														{
															type: "text",
															name: "name",
															header: "Name",
														},
														{
															type: "number",
															name: "amount",
															float: true,
															decimals: 2,
															header: "Value",
														},
														{
															type: "select",
															name: "type",
															header: "Type",
															options: [
																{ value: "dollar", label: "Dollar" },
																{ value: "percent", label: "Percent" },
															],
														},
														{
															type: "textarea",
															name: "wire",
															header: "Wire Instructions",
														},
														{
															type: "select",
															name: "structure",
															header: "Structure",
															options: [
																{ value: "sc", label: "Seller Credit" },
																{ value: "sd", label: "Seller Debit" },
															],
														},
													]}
													data={f.values.finance_data.seller_fees}
													onChange={(v) => f.setFieldValue("finance_data.seller_fees", v)}
												/>
											</div>
											<h3 className="mt-12">Flat Closing Fees</h3>
											<TableRowField
												delete={true}
												fields={[
													{
														type: "text",
														name: "name",
														header: "Name",
													},
													{
														type: "number",
														name: "amount",
														float: true,
														decimals: 2,
														header: "Amount",
													},
													{
														type: "textarea",
														name: "wire",
														header: "Wire Instructions",
													},
													{
														type: "select",
														name: "structure",
														header: "Structure",
														options: [
															{ value: "bdsc", label: "Buyer Debit Seller Credit" },
															{ value: "bcsd", label: "Buyer Credit Seller Debit" },
															{ value: "bd", label: "Buyer Debit" },
															{ value: "sd", label: "Seller Debit" },
														],
													},
												]}
												data={f.values.finance_data.community_flat_fees}
												onChange={(v) => f.setFieldValue("finance_data.community_flat_fees", v)}
											/>
											<h3 className="py-4">Loan Terms</h3>
											<ul className="form__list">
												<li className={fieldStatus("zero_dollars", f)}>
													<label htmlFor="zero_dollars">Zero Dollars to Development?</label>
													{f.errors.zero_dollars && f.touched.zero_dollars && (
														<div className="form__message">{f.errors.zero_dollars}</div>
													)}
													<ReactSelect
														name={`finance_data.zero_dollars`}
														options={[
															{
																label: "No",
																value: false,
															},
															{
																label: "Yes",
																value: true,
															},
														]}
														value={f.values.finance_data.zero_dollars}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("first_lien_release", f)}>
													<label htmlFor="first_lien_release">
														First Lien Release Percent
													</label>
													{f.errors.first_lien_release && f.touched.first_lien_release && (
														<div className="form__message">
															{f.errors.first_lien_release}
														</div>
													)}
													<NumberField
														name="finance_data.first_lien_release"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched?.finance_data?.first_lien_release}
														value={f.values.finance_data.first_lien_release}
														thousandSeparator={true}
														decimals={8}
														float={true}
													/>
												</li>
												<li className={fieldStatus("net_gross", f)}>
													<label htmlFor="net_gross">Net/Gross</label>
													{f.errors.net_gross && f.touched.net_gross && (
														<div className="form__message">{f.errors.net_gross}</div>
													)}
													<ReactSelect
														name={`finance_data.net_gross`}
														options={[
															{
																label: "Net",
																value: "Net",
															},
															{
																label: "Gross",
																value: "Gross",
															},
														]}
														value={f.values.finance_data.net_gross}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("include_escalation", f)}>
													<label htmlFor="include_escalation">Include Escalation?</label>
													{f.errors.include_escalation && f.touched.include_escalation && (
														<div className="form__message">
															{f.errors.include_escalation}
														</div>
													)}
													<ReactSelect
														name={`finance_data.include_escalation`}
														options={[
															{
																label: "Yes (Base Price + Escalation)",
																value: 1,
															},
															{
																label: "No (Base Price Only)",
																value: 0,
															},
														]}
														value={f.values.finance_data.include_escalation}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("indiv_or_takedown", f)}>
													<label htmlFor="indiv_or_takedown">
														By Individual Lot or Total Sale
													</label>
													{f.errors.indiv_or_takedown && f.touched.indiv_or_takedown && (
														<div className="form__message">
															{f.errors.indiv_or_takedown}
														</div>
													)}
													<ReactSelect
														name={`finance_data.indiv_or_takedown`}
														options={[
															{
																label: "Individual",
																value: "individual",
															},
															{
																label: "Takedown",
																value: "takedown",
															},
														]}
														value={f.values.finance_data.indiv_or_takedown}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("funds_lien", f)}>
													<label htmlFor="funds_lien">Funds First Lien</label>
													{f.errors.funds_lien && f.touched.funds_lien && (
														<div className="form__message">{f.errors.funds_lien}</div>
													)}
													<TextArea
														name="finance_data.funds_lien"
														className="form__textarea"
														value={f.values.finance_data.funds_lien}
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.funds_lien}
														error={f.errors.funds_lien}
													/>
												</li>
											</ul>
											<ul className="form__list">
												<li className={fieldStatus("earnest_monies_net", f)}>
													<label htmlFor="earnest_monies_net">
														Earnest Monies Net Against First Lien?
													</label>
													{f.errors.earnest_monies_net && f.touched.earnest_monies_net && (
														<div className="form__message">
															{f.errors.earnest_monies_net}
														</div>
													)}
													<ReactSelect
														name={`finance_data.earnest_monies_net`}
														options={[
															{
																label: "No",
																value: 0,
															},
															{
																label: "Yes",
																value: 1,
															},
														]}
														value={f.values.finance_data?.earnest_monies_net}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("lump_sum_earnest", f)}>
													<label htmlFor="lump_sum_earnest">
														Lump Sum Earnest Money Nets Against First Lien?
													</label>
													{f.errors.lump_sum_earnest && f.touched.lump_sum_earnest && (
														<div className="form__message">{f.errors.lump_sum_earnest}</div>
													)}
													<ReactSelect
														name={`finance_data.lump_sum_earnest`}
														options={[
															{
																label: "No",
																value: 0,
															},
															{
																label: "Yes",
																value: 1,
															},
														]}
														clearable
														value={f.values.finance_data?.lump_sum_earnest}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("taxes_net_fl", f)}>
													<label htmlFor="taxes_net_fl">Taxes Net Against First Lien?</label>
													{f.errors.taxes_net_fl && f.touched.taxes_net_fl && (
														<div className="form__message">{f.errors.taxes_net_fl}</div>
													)}
													<ReactSelect
														name={`finance_data.taxes_net_fl`}
														options={[
															{
																label: "No",
																value: 0,
															},
															{
																label: "Yes",
																value: 1,
															},
														]}
														value={f.values.finance_data?.taxes_net_fl}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("closing_net_against_fl", f)}>
													<label htmlFor="closing_net_against_fl">
														Closing Costs Net Against First Lien?
													</label>
													{f.errors.closing_net_against_fl &&
														f.touched.closing_net_against_fl && (
															<div className="form__message">
																{f.errors.closing_net_against_fl}
															</div>
														)}
													<ReactSelect
														name={`finance_data.closing_net_against_fl`}
														options={[
															{
																label: "No",
																value: 0,
															},
															{
																label: "Yes",
																value: 1,
															},
														]}
														value={f.values.finance_data?.closing_net_against_fl}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("partnership_net_fl", f)}>
													<label htmlFor="partnership_net_fl">
														Partnership Monies Net Against First Lien?
													</label>
													{f.errors.partnership_net_fl && f.touched.partnership_net_fl && (
														<div className="form__message">
															{f.errors.partnership_net_fl}
														</div>
													)}
													<ReactSelect
														name={`finance_data.partnership_net_fl`}
														options={[
															{
																label: "No",
																value: 0,
															},
															{
																label: "Yes",
																value: 1,
															},
														]}
														value={f.values.finance_data?.partnership_net_fl}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
														clearable
													/>
												</li>
												<li className={fieldStatus("finance_data.current_loan_agreement", f)}>
													<label htmlFor="finance_data.current_loan_agreement">
														Current Loan Agreement{" "}
														{currentLoan ? (
															<a
																href={settings.s3 + currentLoan}
																target="_blank"
																className="text-xs ml-2">
																[Current File]
															</a>
														) : (
															""
														)}
													</label>
													<input
														name="finance_data.current_loan_agreement"
														type="file"
														id="finance_data.current_loan_agreement"
														className={classNames("noBorder", {
															fileHideText: fields?.finance_data?.current_loan_agreement,
														})}
														//className="noBorder fileHideText"
														onChange={(event) => {
															f.setFieldValue(
																"finance_data.current_loan_agreement",
																event.currentTarget.files[0]
															)
														}}
													/>
												</li>
											</ul>
											<TableRowField
												delete={true}
												fields={[
													{
														type: "select",
														name: "lot_type",
														lookup: "lot_types",
														header: "Lot Type",
														clearable: true,
														dependent: "property",
														dependentVal: props.activeProperties?.[0],
													},
													{
														type: "number",
														name: "minimum",
														float: true,
														decimals: 2,
														header: "Minimum",
													},
												]}
												data={f.values.finance_data.first_lien_minimums}
												onChange={(v) => f.setFieldValue("finance_data.first_lien_minimums", v)}
											/>
											<h2>Borrowing Base</h2>
											<ul className="form__list">
												<li className={fieldStatus("lender", f)}>
													<label htmlFor="lender">Lender</label>
													{f.errors.lender && f.touched.lender && (
														<div className="form__message">{f.errors.lender}</div>
													)}
													<Field
														name="finance_data.lender"
														type="text"
														className="form__input"
													/>
												</li>
												<li className={fieldStatus("lender_discount_rate", f)}>
													<label htmlFor="lender_discount_rate">Lender Discount Rate %</label>
													{f.errors.lender_discount_rate &&
														f.touched.lender_discount_rate && (
															<div className="form__message">
																{f.errors.lender_discount_rate}
															</div>
														)}
													<NumberField
														name="finance_data.lender_discount_rate"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched?.finance_data?.lender_discount_rate}
														value={f.values.finance_data.lender_discount_rate}
														thousandSeparator={true}
														decimals={2}
														suffix={"%"}
													/>
												</li>
												<li>&nbsp;</li>
												<li className={fieldStatus("res_remaining_acreage", f)}>
													<label htmlFor="res_remaining_acreage">
														Residential Remaining Acreage
													</label>
													{f.errors.res_remaining_acreage &&
														f.touched.res_remaining_acreage && (
															<div className="form__message">
																{f.errors.res_remaining_acreage}
															</div>
														)}
													<NumberField
														name="finance_data.res_remaining_acreage"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched?.finance_data?.res_remaining_acreage}
														value={f.values.finance_data.res_remaining_acreage}
														thousandSeparator={true}
														decimals={3}
													/>
												</li>
												<li className={fieldStatus("res_value_per_acre", f)}>
													<label htmlFor="res_value_per_acre">
														Residential Value Per Acre
													</label>
													{f.errors.res_value_per_acre && f.touched.res_value_per_acre && (
														<div className="form__message">
															{f.errors.res_value_per_acre}
														</div>
													)}
													<NumberField
														name="finance_data.res_value_per_acre"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched?.finance_data?.res_value_per_acre}
														value={f.values.finance_data.res_value_per_acre}
														thousandSeparator={true}
														decimals={3}
													/>
												</li>
												<li className={fieldStatus("", f)}>
													<label htmlFor="res_value_per_acre">
														Residential Acreage Value
													</label>
													{numeral(
														f.values.finance_data?.res_value_per_acre *
															f.values.finance_data?.res_remaining_acreage
													).format("$0,0.00") || ""}
												</li>
												<li className={fieldStatus("com_remaining_acreage", f)}>
													<label htmlFor="com_remaining_acreage">
														Commercial Remaining Acreage
													</label>
													{f.errors.com_remaining_acreage &&
														f.touched.com_remaining_acreage && (
															<div className="form__message">
																{f.errors.com_remaining_acreage}
															</div>
														)}
													<NumberField
														name="finance_data.com_remaining_acreage"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched?.finance_data?.com_remaining_acreage}
														value={f.values.finance_data.com_remaining_acreage}
														thousandSeparator={true}
														decimals={3}
													/>
												</li>
												<li className={fieldStatus("com_value_per_acre", f)}>
													<label htmlFor="com_value_per_acre">
														Commercial Value Per Acre
													</label>
													{f.errors.com_value_per_acre && f.touched.com_value_per_acre && (
														<div className="form__message">
															{f.errors.com_value_per_acre}
														</div>
													)}
													<NumberField
														name="finance_data.com_value_per_acre"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched?.finance_data?.com_value_per_acre}
														value={f.values.finance_data.com_value_per_acre}
														thousandSeparator={true}
														decimals={3}
													/>
												</li>
												<li className={fieldStatus("", f)}>
													<label htmlFor="res_value_per_acre">Commercial Acreage Value</label>
													{numeral(
														f.values.finance_data?.com_value_per_acre *
															f.values.finance_data?.com_remaining_acreage
													).format("$0,0.00") || ""}
												</li>
												<li className={fieldStatus("mud_receiveables", f)}>
													<label htmlFor="mud_receiveables">MUD Receiveables</label>
													{f.errors.mud_receiveables && f.touched.mud_receiveables && (
														<div className="form__message">{f.errors.mud_receiveables}</div>
													)}
													<NumberField
														name="finance_data.mud_receiveables"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched?.finance_data?.mud_receiveables}
														value={f.values.finance_data.mud_receiveables}
														thousandSeparator={true}
														decimals={2}
													/>
												</li>
												<li className={fieldStatus("mud_discount_rate", f)}>
													<label htmlFor="mud_discount_rate">MUD Discount Rate %</label>
													{f.errors.mud_discount_rate && f.touched.mud_discount_rate && (
														<div className="form__message">
															{f.errors.mud_discount_rate}
														</div>
													)}
													<NumberField
														name="finance_data.mud_discount_rate"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched?.finance_data?.mud_discount_rate}
														value={f.values.finance_data.mud_discount_rate}
														thousandSeparator={true}
														decimals={2}
														suffix={"%"}
													/>
												</li>
												<li className={fieldStatus("", f)}>
													<label htmlFor="res_value_per_acre">MUD Rec Value</label>
													{numeral(
														f.values.finance_data?.mud_receiveables *
															(f.values.finance_data?.mud_discount_rate / 100)
													).format("$0,0.00") || ""}
												</li>
											</ul>

											<h2>Wire Instructions</h2>
											<ul className="form__list">
												<li className={fieldStatus("funds_proceeds", f)}>
													<label htmlFor="funds_proceeds">Funds Proceeds</label>
													{f.errors.funds_proceeds && f.touched.funds_proceeds && (
														<div className="form__message">{f.errors.funds_proceeds}</div>
													)}
													<TextArea
														name="finance_data.funds_proceeds"
														className="form__textarea"
														value={f.values.finance_data.funds_proceeds}
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.funds_proceeds}
														error={f.errors.funds_proceeds}
													/>
												</li>
											</ul>
											<h2>Tax Rates</h2>
											<div className="min-h-[40px] mt-3">
												<ul className="flex">
													{taxRates.map((v, i) => {
														let output = `${v.name} - ${v.rate}`
														let rate = parseFloat(v.rate)
														if (!rate) {
															output = (
																<>
																	<input
																		type="number"
																		className="text-black"
																		value={taxTemp}
																		onChange={(e) => {
																			setTaxTemp(parseFloat(e.target.value))
																		}}
																	/>
																	<span>- {v.name}</span>
																</>
															)
														}
														return (
															<li
																className={classNames(
																	`inline-flex items-center mr-1 border rounded-sm bg-red-400 text-xs border-red-700`,
																	{
																		"pr-2": rate,
																	}
																)}
																key={i}>
																<i
																	className="fa-light fa-xmark text-white bg-red-600 mr-2 text-sm px-2 font-bold cursor-pointer transition duration-300 hover:bg-red-400"
																	onClick={() => {
																		let rates = _.clone(taxRates)
																		let f = _.filter(rates, (r) => r.id !== v.id)
																		setTaxRates(f)
																	}}></i>
																<span className="leading-none text-white -translate-y-[1px] inline-block">
																	{output}
																</span>
																{!rate ? (
																	<span
																		className="bg-green-600 text-white text-xs h-full px-2 flex items-center transition duration-300 hover:bg-green-500 cursor-pointer"
																		onClick={() => {
																			// store on the server
																			let values = {}
																			values.action = "saveTaxRate"
																			values.tax_number = v.tax_number
																			values.rate = taxTemp
																			submitData("mainIngest", values)
																			let rates = _.clone(taxRates)
																			rates[i].rate = taxTemp
																			setTaxRates(rates)
																			setTaxTemp(0)
																		}}>
																		Save
																	</span>
																) : null}
															</li>
														)
													})}
												</ul>
												<p className="text-sm mt-3">
													{taxTotal ? (
														<>
															Estimated Total: {taxTotal}
															<span
																className="bg-green-600 text-white text-xs cursor-pointer px-2 py-1 rounded-lg ml-4"
																onClick={() => {
																	f.setFieldValue(
																		"finance_data.estimated_tax_rate",
																		taxTotal
																	)
																	// save these tax rates to the community in finance_data
																	submitData("mainIngest", {
																		action: "saveTaxRatesToProperty",
																		property: props.match.params.id,
																		rates: JSON.stringify(
																			_.map(taxRates, (v) => v.tax_number)
																		),
																	})
																}}>
																Apply
															</span>
														</>
													) : null}
												</p>
											</div>
											<div className="flex justify-between">
												<div className="w-6/12">
													<li className={`${fieldStatus("estimated_tax_rate", f)} mt-2`}>
														<label htmlFor="estimated_tax_rate">Estimated Tax Rate</label>
														{f.errors.estimated_tax_rate &&
															f.touched.estimated_tax_rate && (
																<div className="form__message">
																	{f.errors.estimated_tax_rate}
																</div>
															)}
														<NumberField
															name="finance_data.estimated_tax_rate"
															className="form__input"
															onChange={f.setFieldValue}
															onBlur={f.setFieldTouched}
															touched={f.touched.finance_data?.estimated_tax_rate}
															value={f.values.finance_data?.estimated_tax_rate}
															thousandSeparator={true}
															decimals={8}
															float={true}
														/>
													</li>
												</div>
												<div className="w-5/12 flex flex-col justify-end">
													<Typeahead
														name="event_id"
														className="form__input"
														fullWidth={true}
														onChange={(k, v) => {
															if (v === -1) return
															let rates = _.clone(taxRates)
															rates.push(v)
															setTaxRates(rates)
															console.log(rates)
														}}
														onBlur={f.setFieldTouched}
														touched={f.touched.event_id}
														error={f.errors.event_id}
														val
														placeholder={"Search Tax Rates"}
														ep="/typeaheadTaxRates"
														returnAll={true}
														clearAfter={true}
													/>
												</div>
											</div>
											<h2>Community Specific Lot Fees</h2>
											<TableRowField
												delete={true}
												name="community_specific_fees"
												fields={[
													{
														type: "text",
														name: "fee",
														header: "Fee",
													},
													{
														type: "number",
														name: "default",
														float: true,
														decimals: 2,
														header: "Default Amount (optional)",
													},
													{
														type: "select",
														name: "lot_type",
														lookup: "lot_types",
														header: "Lot Type",
														placeholder: "All Lots",
														clearable: true,
														dependent: "property",
														dependentVal: props.activeProperties?.[0],
													},
													{
														type: "textarea",
														name: "wire",
														header: "Wire Instructions",
													},
													{
														type: "select",
														name: "structure",
														header: "Structure",
														options: [
															{ value: "bdsc", label: "Buyer Debit Seller Credit" },
															{ value: "bcsd", label: "Buyer Credit Seller Debit" },
															{ value: "bd", label: "Buyer Debit" },
															{ value: "sd", label: "Seller Debit" },
														],
													},
												]}
												data={f.values.finance_custom}
												onChange={(v) => f.setFieldValue("finance_custom", v)}
											/>
										</div>
									) : null}
									<input type="submit" value="Submit" className={submitClasses(f.isValid)} />
								</Form>
							</div>
						)}
					</Formik>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(EditCommunity)
